// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseEnvironmentConfig } from './ResponseEnvironmentConfig';
import {
  ResponseEnvironmentConfigFromJSON,
  ResponseEnvironmentConfigFromJSONTyped,
  ResponseEnvironmentConfigToJSON,
  ResponseEnvironmentConfigToJSONTyped,
} from './ResponseEnvironmentConfig';

/**
 *
 * @export
 * @interface ResponseEnvironmentConfigList
 */
export interface ResponseEnvironmentConfigList {
  /**
   *
   * @type {Array<ResponseEnvironmentConfig>}
   * @memberof ResponseEnvironmentConfigList
   */
  items?: Array<ResponseEnvironmentConfig>;
}

/**
 * Check if a given object implements the ResponseEnvironmentConfigList interface.
 */
export function instanceOfResponseEnvironmentConfigList(
  value: object,
): value is ResponseEnvironmentConfigList {
  return true;
}

export function ResponseEnvironmentConfigListFromJSON(
  json: any,
): ResponseEnvironmentConfigList {
  return ResponseEnvironmentConfigListFromJSONTyped(json, false);
}

export function ResponseEnvironmentConfigListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseEnvironmentConfigList {
  if (json == null) {
    return json;
  }
  return {
    items:
      json['items'] == null
        ? undefined
        : (json['items'] as Array<any>).map(ResponseEnvironmentConfigFromJSON),
  };
}

export function ResponseEnvironmentConfigListToJSON(
  json: any,
): ResponseEnvironmentConfigList {
  return ResponseEnvironmentConfigListToJSONTyped(json, false);
}

export function ResponseEnvironmentConfigListToJSONTyped(
  value?: ResponseEnvironmentConfigList | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    items:
      value['items'] == null
        ? undefined
        : (value['items'] as Array<any>).map(ResponseEnvironmentConfigToJSON),
  };
}
